(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-frequency-to', {
            parent: 'entity',
            url: '/med-frequency-to',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency To'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-tos.html',
                    controller: 'MedFrequencyToController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('med-frequency-to-detail', {
            parent: 'entity',
            url: '/med-frequency-to/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Frequency To'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-detail.html',
                    controller: 'MedFrequencyToDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MedFrequencyTo', function($stateParams, MedFrequencyTo) {
                    return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'med-frequency-to',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('med-frequency-to-detail.edit', {
            parent: 'med-frequency-to-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-dialog.html',
                    controller: 'MedFrequencyToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyTo', function(MedFrequencyTo) {
                            return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-to.new', {
            parent: 'med-frequency-to',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-dialog.html',
                    controller: 'MedFrequencyToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-frequency-to', null, { reload: 'med-frequency-to' });
                }, function() {
                    $state.go('med-frequency-to');
                });
            }]
        })
        .state('med-frequency-to.edit', {
            parent: 'med-frequency-to',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-dialog.html',
                    controller: 'MedFrequencyToDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedFrequencyTo', function(MedFrequencyTo) {
                            return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-to', null, { reload: 'med-frequency-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-frequency-to.delete', {
            parent: 'med-frequency-to',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-frequency-to/med-frequency-to-delete-dialog.html',
                    controller: 'MedFrequencyToDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedFrequencyTo', function(MedFrequencyTo) {
                            return MedFrequencyTo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-frequency-to', null, { reload: 'med-frequency-to' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
